<div class="scan-backdrop">
  <button class="scan-close" (click)="close()">
    <ion-icon name="close-outline"></ion-icon>
  </button>
  <div class="scan-container">
    <video #video autoplay playsinline muted class="scan-video"></video>
    <div class="scan-frame"></div>
  </div>
  <p class="scan-hint">Barcode in den Rahmen halten</p>
</div>
